import { PersonPhonenumberSource as Source } from "../generated/django-enums";
import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";

export { Source };

export type PersonPhonenumber = {
	id?: number;
	person: number;
	phonenumber: string;
	e164_phonenumber?: string;
	source: number;
};

export const getPersonPhonenumberById = (
	personId: number
): Promise<DRFListResponseWrapper<PersonPhonenumber[]>> => {
	if (!personId || typeof personId !== "number") {
		throw new Error(
			`getPersonPhonenumberById called with invalid argument id '${personId}'. Expected number`
		);
	}

	return fetch(`/api/v2/persons/${personId}/phonenumber/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const createPersonPhonenumberByPersonId = (
	personId: number,
	phonenumber: string
): Promise<PersonPhonenumber> => {
	if (!personId || typeof personId !== "number") {
		throw new Error(
			`getPersonPhonenumberById called with invalid argument id '${personId}'. Expected number`
		);
	}

	const data: PersonPhonenumber = {
		phonenumber: phonenumber,
		source: Source.MANUAL,
		person: personId,
	};

	return fetch(`/api/v2/persons/${personId}/phonenumber/`, {
		body: JSON.stringify(data),
		method: "POST",
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
	}).then((res) => {
		if (res.status !== 201) {
			throw new Error("Could not create number");
		}
		return res.json();
	});
};

export const deletePersonPhonenumber = (personId: number, numberId: number) => {
	return fetch(`/api/v2/persons/${personId}/phonenumber/${numberId}/`, {
		method: "DELETE",
		headers: {
			...getGlobalHeadersAsObject(),
		},
	}).then((res) => {
		console.log(res);
	});
};
